import { z } from 'zod';

export const puzzleResultSchema = z.object({
  puzzleId: z.string(),
  date: z.string().regex(/^\d{4}-\d{2}-\d{2}$/),
  seconds: z.number().nonnegative(),
  firstTryCorrect: z.number().int().min(0).max(4),
});

export const localStatsSchema = z.object({
  schemaVersion: z.literal(1),
  streak: z.number().int().min(0),
  maxStreak: z.number().int().min(0),
  totalPlayed: z.number().int().min(0),
  totalWon: z.number().int().min(0),
  lastPlayedDate: z.string().regex(/^\d{4}-\d{2}-\d{2}$/).nullable(),
  history: z.array(puzzleResultSchema),
});

export type ParsedLocalStats = z.infer<typeof localStatsSchema>;
